import { Industry } from '@ViewModels';
import { css, StyleSheet } from 'aphrodite';
import { useHistory } from 'react-router-dom';
import { MastheadPortalId } from '../../../../models/AdminModels';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { NavigationBreadcrumbsBar } from '../../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../../web/components/Portal';
import { bs, CssSelectors } from '../../../../web/styles/styles';
import { IndustryTemplates } from '../IndustryTemplates';
import { IndustryTemplatesCreateButton } from '../IndustryTemplates/prensentation';
import { SurveyTemplatesByIndustry } from '../SurveyTemplatesByIndustry';
import { styleSheet } from './styles';

export function SurveyTemplates() {
	const history = useHistory();

	const onRenderTemplatesByIndustryRoute = (industry: Industry) => {
		return <SurveyTemplatesByIndustry industry={industry} />;
	};

	const handleCreateTemplate = () => {
		history.push('/surveys/template/custom/new');
	};

	return (
		<div className={`${css(styleSheet.container)} survey-templates`}>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar />
			</Portal>
			<IndustryTemplates onRenderTemplatesByIndustryRoute={onRenderTemplatesByIndustryRoute}>
				<div className={css(bs.horizontalStack, createTemplateStyles.createButtons)}>
					<IndustryTemplatesCreateButton onClick={handleCreateTemplate}>
						Custom Survey Template
					</IndustryTemplatesCreateButton>
				</div>
			</IndustryTemplates>
		</div>
	);
}

const createTemplateStyles = StyleSheet.create({
	createButtons: {
		margin: `${THEME.spacing.md}px 0 ${THEME.spacing.xl}px 0`,
		gap: 12,
		...CssSelectors.allChildren(
			{
				maxWidth: '25%',
			},
			'button'
		),
	},
});
